import React from "react";

import { useTranslation } from "utils";

import { Col, Input, InputPassword, Row } from "components";

export const SignInInputs = () => {
  const { t } = useTranslation("signinup");

  return (
    <>
      <Row>
        <Col>
          <Input
            dataTestId="sign-in-input-email"
            name="email"
            label={t("signin.inputs.email")}
            rules={[
              {
                required: true,
                type: "email",
              },
            ]}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <InputPassword
            dataTestId="sign-in-input-password"
            PasswordStrengthPopup
            name="password"
            label={t("signin.inputs.password")}
            rules={[{ required: true }]}
          />
        </Col>
      </Row>
    </>
  );
};
